import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";

function toPascal(str) {
  return String(str || "sparkles").split(/[-_ ]/).map(s => s.charAt(0).toUpperCase() + s.slice(1)).join("");
}

export default function Skills({ skills }) {
  const list = (skills || []).sort((a, b) => (a.order || 0) - (b.order || 0));
  return (
    <section id="skills" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.28em] uppercase text-slate-500">What you'll learn</div>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl leading-tight text-[#0B132B]">Build Skills That Matter in Real Interviews</h2>
        </div>
        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((s, i) => {
            const Icon = Icons[toPascal(s.icon)] || Icons.Sparkles;
            return (
              <motion.div key={s.id || s.title}
                          initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                          transition={{ delay: (i % 6) * 0.06 }}
                          className="group relative rounded-2xl p-6 ring-1 ring-slate-100 bg-gradient-to-br from-white to-slate-50 hover:-translate-y-1 hover:shadow-elev transition-transform">
                <div className="flex items-start justify-between">
                  <div className="h-11 w-11 rounded-xl bg-[#0B132B] text-white grid place-items-center group-hover:rotate-3 transition-transform">
                    <Icon size={18} />
                  </div>
                  <span className="text-[10px] tracking-widest text-slate-400">SKILL · {String(i + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-4 font-display text-lg text-[#0B132B]">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
